module.exports = __webpack_public_path__ + "static/media/22.3c6d878.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/22.wav
// module id = 5KSL
// module chunks = 0